module.exports = __webpack_public_path__ + "static/media/9.ac706538.JPG";